var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"help-tooltip",attrs:{"alt":"","src":_vm.getSrc('help.svg'),"title":_vm.$t(_vm.tooltipText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }